import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ajukanJurnalHarian, updateJurnalHarian } from "../services/jurnalHarianService";
import BottomNavbar from "../components/BottomNavbar";
import logo from "../assets/EPRAJOGO1.png";

function InputJurnalHarian() {
  const navigate = useNavigate();
  const location = useLocation();
  const journal = location.state?.journal;
  const isDraft = !journal || journal.status_verifikasi === 'draft';
  const submitting = useRef(false);
  const [tanggal, setTanggal] = useState(journal?.tanggal?.slice(0, 10) || "");
  const [pekerjaan, setPekerjaan] = useState(journal?.pekerjaan || "");
  const [catatan, setCatatan] = useState(journal?.catatan || "");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting.current) return;
    const siswaId = localStorage.getItem("user_id");
    if (!siswaId) return alert('Sesi berakhir. Login kembali.');
    if (!isDraft && (!tanggal || !pekerjaan.trim())) return alert('Lengkapi tanggal dan pekerjaan.');
    submitting.current = true;
    setLoading(true);
    try {
      const values = { ...(tanggal ? { tanggal } : {}), pekerjaan, catatan, siswa_id: siswaId };
      const result = journal
        ? await updateJurnalHarian(journal.id, values)
        : await ajukanJurnalHarian(values);
      if (result.success) {
        alert(result.message || (isDraft ? 'Draft disimpan. Kirim ke guru dari daftar jurnal setelah lengkap.' : 'Jurnal diperbaiki dan dikirim ulang.'));
        navigate("/jurnal-harian");
      } else {
        alert(result.message || "Gagal menyimpan jurnal harian");
      }
    } catch (error) {
      alert(error.message || 'Gagal menyimpan jurnal harian.');
    } finally {
      submitting.current = false;
      setLoading(false);
    }
  };

  return (
    <main className="app-mobile-page">
      <header className="app-brand-header">
        <div className="app-brand-row">
          <img src={logo} alt="Logo E-Prajogo" className="app-brand-logo" />
          <div><p className="app-brand-name">E-PRAJOGO</p><p className="app-brand-school">SMK NEGERI GUDO</p></div>
          <span className="ms-auto rounded-pill px-3 py-2 small fw-semibold" style={{ background: "#ffffff20", color: "#fff" }}>SISWA</span>
        </div>
        <h1 className="app-header-title">{journal ? (isDraft ? 'Edit Draft Harian' : "Perbaiki Jurnal Harian") : "Input Jurnal Harian"}</h1>
        <p className="app-header-subtitle">{isDraft ? 'Simpan dulu sebagai draft. Kirim ke guru setelah isian lengkap.' : 'Perbaikan akan dikirim ulang untuk verifikasi guru.'}</p>
      </header>

      <section className="app-content">
      <form className="journal-form-card" onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="journal-date" className="form-label fw-bold">Tanggal</label>
          <input
            id="journal-date"
            type="date"
            className="form-control"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            required={!isDraft}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="journal-work" className="form-label fw-bold">Pekerjaan</label>
          <input
            id="journal-work"
            type="text"
            className="form-control"
            placeholder="Masukkan pekerjaan hari ini"
            value={pekerjaan}
            onChange={(e) => setPekerjaan(e.target.value)}
            required={!isDraft}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="journal-note" className="form-label fw-bold">Catatan</label>
          <textarea
            id="journal-note"
            className="form-control"
            rows="3"
            placeholder="Masukkan catatan tambahan"
            value={catatan}
            onChange={(e) => setCatatan(e.target.value)}
          />
        </div>

        <button type="submit" className="btn btn-primary w-100" disabled={loading}>
          {loading ? <><span className="spinner-border spinner-border-sm me-2" />Menyimpan...</> : <><i className="bi bi-save me-2"></i>{isDraft ? "Simpan draft" : "Kirim Ulang untuk Verifikasi"}</>}
        </button>
      </form>
      </section>
      <BottomNavbar />
    </main>
  );
}

export default InputJurnalHarian;
